import React from 'react'
import { useStateAuthContext, useStateHostContext } from '../context'
import { FaEdit, FaSave, FaTimes } from 'react-icons/fa'
import { error, success } from '../notify'
import { BeatLoader } from 'react-spinners'

const Opd_profil_kop = () => {
  window.document.title = "Profil Kop Surat"
  const { HOST } = useStateHostContext();
  const { STATE_AUTH } = useStateAuthContext();
  const form_ref = React.useRef()
  const [is_submit, set_submit] = React.useState(false);
  const [id_kop, set_id_kop] = React.useState("")
  const [id_opd] = React.useState(STATE_AUTH.id_opd)
  const [title_1, set_title_1] = React.useState("PEMERINTAH KOTA KOTAMOBAGU")
  const [title_2, set_title_2] = React.useState("")
  const [title_3, set_title_3] = React.useState("")
  const [title_4, set_title_4] = React.useState("")
  const [loading, set_loading] = React.useState(false)
  const [menu_view, set_menu_view] = React.useState(1)


  const ambilDataProfile = React.useCallback(async () => {
    set_loading(true)
    try {
      const request = await fetch(`${HOST}/kop_surat/profil/` + STATE_AUTH.id_opd, {
        method: 'GET',
        headers: {
          "REST-ID-OPD": STATE_AUTH.id_opd,
          "REST-TOKEN": STATE_AUTH.token
        }
      })

      const response = await request.json()
      if (request.ok) {
        if (response.s) {
          set_id_kop(response.d.id_kop)
          set_title_1(response.d.title_1 || "PEMERINTAH KOTA KOTAMOBAGU")
          set_title_2(response.d.title_2 || STATE_AUTH.nama_opd)
          set_title_3(response.d.title_3)
          set_title_4(response.d.title_4)
          set_loading(false)
        } else {
          error({ msg: response.m })
          set_loading(false)
        }
      } else {
        throw new Error(response.m)
      }
    }
    catch (err) {
      error({ msg: err.message })
      set_loading(false)
    }
  }, [HOST, STATE_AUTH])


  React.useEffect(() => {
    ambilDataProfile()
  }, [ambilDataProfile])

  const handleSubmit = async (e) => {
    e.preventDefault()
    set_submit(true)
    const formData = new FormData()
    formData.append('ID_KOP', id_kop)
    formData.append('ID_OPD', id_opd)
    formData.append('TITLE_1', title_1)
    formData.append('TITLE_2', title_2)
    formData.append('TITLE_3', title_3)
    formData.append('TITLE_4', title_4)

    try {
      let host = "";
      if (!id_kop) {
        host = `${HOST}/kop_surat/buat`
      } else {
        host = `${HOST}/kop_surat/ubah`
      }
      const request = await fetch(host, {
        method: 'POST',
        headers: {
          "REST-ID-OPD": STATE_AUTH.id_opd,
          "REST-TOKEN": STATE_AUTH.token
        },
        body: formData
      })

      const response = await request.json()
      if (request.ok) {
        if (response.s) {
          success({ msg: response.m })
          set_submit(false)
          ambilDataProfile()
          set_menu_view(1)
        } else {
          error({ msg: response.m })
          set_submit(false)
        }
      }

    } catch (error) {
      error({ msg: error.message })
      set_submit(false)
    }

  }

  return (
    <main>
      <div className="container-fluid">
        <div className="row mt-3">
          <div className="col-md-12">
            <h3><strong><i className='far fa-file-alt'></i> KOP SURAT</strong></h3>
          </div>
        </div>
        <hr />
        <div className="row">
          {
            !loading
              ?
              menu_view === 1
                ?
                <div className="col-md-12">
                  <ul className='list-group'>
                    <li className='list-group-item d-flex flex-column'><small>TITLE 1</small><p className='p-0 m-0 fw-bold'>{title_1 ? title_1 : '(Masih Kosong)'}</p></li>
                    <li className='list-group-item d-flex flex-column'><small>TITLE 2</small><p className='p-0 m-0 fw-bold'>{title_2 ? title_2 : '(Masih Kosong)'}</p></li>
                    <li className='list-group-item d-flex flex-column'><small>TITLE 3</small><p className='p-0 m-0 fw-bold'>{title_3 ? title_3 : '(Masih Kosong)'}</p></li>
                    <li className='list-group-item d-flex flex-column'><small>TITLE 4</small><p className='p-0 m-0 fw-bold'>{title_4 ? title_4 : '(Masih Kosong)'}</p></li>
                  </ul>
                  <button className='btn btn-sm btn-warning my-3' onClick={() => set_menu_view(2)}> <FaEdit /> Perbaharui</button>
                </div>
                :
                <form onSubmit={handleSubmit} ref={form_ref}>
                  <div className="col-md-12">
                    <h6 className='p-2 bg-info'> <i className='fa fa-info-circle'></i>FORM UBAH INFORMASI KOP SURAT</h6>
                    <div className="input-group input-group-sm mb-1">
                      <span className="input-group-text" id="title1" style={{ width: '25%' }}>Title 1</span>
                      <input name="title1" type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" required onChange={e => set_title_1(e.target.value)} value={title_1} autoComplete="off" readOnly />
                    </div>
                    <div className="input-group input-group-sm mb-1">
                      <span className="input-group-text" id="title2" style={{ width: '25%' }}>Title 2</span>
                      <input name="title2" type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={e => set_title_2(e.target.value)} value={title_2} autoComplete="off" readOnly />
                    </div>
                    <div className="input-group input-group-sm mb-1">
                      <span className="input-group-text" id="title3" style={{ width: '25%' }}>Title 3</span>
                      <input name="title3" type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={e => set_title_3(e.target.value)} value={title_3} autoComplete="off"  placeholder='Jl.Ahmad Yani Nomor 3 ....'/>
                    </div>
                    <div className="input-group input-group-sm mb-1">
                      <span className="input-group-text" id="title4" style={{ width: '25%' }}>Title 4</span>
                      <input name="title4" type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={e => set_title_4(e.target.value)} value={title_4} autoComplete="off" placeholder='Telp:082134, Wa:081234, Email:xxxx@kotamobagu.go.id'/>
                    </div>
                    <button type='button' className='btn btn-warning btn-sm mt-2 me-2' onClick={() => set_menu_view(1)}><FaTimes /> Batal</button>
                    <button type='submit' className='btn btn-primary btn-sm mt-2' disabled={is_submit}>
                      <FaSave /> {is_submit ? 'Mohon tunggu...' : 'Simpan Pembaruan'}
                    </button>
                  </div>
                </form>
              :
              <div className="col-md-12 d-flex justify-content-center">
                <BeatLoader />
              </div>
          }

        </div>
      </div>

    </main>
  )
}

export default Opd_profil_kop;